/* tslint:disable */
/* eslint-disable */
/**
 * Xerjoff.Agenti.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DipendenzaCreateDTO
 */
export interface DipendenzaCreateDTO {
    /**
     * 
     * @type {string}
     * @memberof DipendenzaCreateDTO
     */
    nome?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DipendenzaCreateDTO
     */
    indirizzo?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DipendenzaCreateDTO
     */
    cap?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DipendenzaCreateDTO
     */
    citta?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DipendenzaCreateDTO
     */
    provinciaCodice?: string | null;
}

/**
 * Check if a given object implements the DipendenzaCreateDTO interface.
 */
export function instanceOfDipendenzaCreateDTO(value: object): value is DipendenzaCreateDTO {
    return true;
}

export function DipendenzaCreateDTOFromJSON(json: any): DipendenzaCreateDTO {
    return DipendenzaCreateDTOFromJSONTyped(json, false);
}

export function DipendenzaCreateDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): DipendenzaCreateDTO {
    if (json == null) {
        return json;
    }
    return {
        
        'nome': json['nome'] == null ? undefined : json['nome'],
        'indirizzo': json['indirizzo'] == null ? undefined : json['indirizzo'],
        'cap': json['cap'] == null ? undefined : json['cap'],
        'citta': json['citta'] == null ? undefined : json['citta'],
        'provinciaCodice': json['provinciaCodice'] == null ? undefined : json['provinciaCodice'],
    };
}

  export function DipendenzaCreateDTOToJSON(json: any): DipendenzaCreateDTO {
      return DipendenzaCreateDTOToJSONTyped(json, false);
  }

  export function DipendenzaCreateDTOToJSONTyped(value?: DipendenzaCreateDTO | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'nome': value['nome'],
        'indirizzo': value['indirizzo'],
        'cap': value['cap'],
        'citta': value['citta'],
        'provinciaCodice': value['provinciaCodice'],
    };
}

